module.exports = __webpack_public_path__ + "img/paypal.d4d85c93.svg";